import React from 'react'
import { observer } from 'mobx-react'

function CarOverviewListItem ({ title, content }) {
  if (!title || !content) {
    return null
  }

  return (
    <div className='car-overview__list-item'>
      <div className='car-overview__list-item-title'>{title}</div>
      {typeof content === 'string'
        ? <div className='car-overview__list-item-content' dangerouslySetInnerHTML={{ __html: content }}/>
        : <div className='car-overview__list-item-content'>{content}</div>
      }
    </div>
  )
}

export default observer(CarOverviewListItem)
